<template>
  <div class="page">
    <div class="container">
      <div class="page__row page__companies">
        <div class="page__inner">
          <p class="page__counter">01</p>
          <h1 class="subtitle subtitle_red page__subtitle" style="top: -22px">Проведение кампаний общенационального<br>
            масштаба
          </h1>
        </div>
        <div class="page__grid">
          <div class="page__inner page__inner_small">
            <p class="page__counter page__counter_small">02</p>
            <h1 class="subtitle page__subtitle page__subtitle_small subtitle_red">Выстраивание эффективного диалога между государством, бизнесом и обществом</h1>
          </div>
          <div class="page__inner page__inner_small">
            <p class="page__counter page__counter_small">03</p>
            <h1 class="subtitle page__subtitle page__subtitle_small subtitle_red">Развитие экосистемы партнерства в рамках решения задач</h1>
          </div>
          <div class="page__inner page__inner_small">
            <p class="page__counter page__counter_small">05</p>
            <h1 class="subtitle page__subtitle page__subtitle_small subtitle_red">Антикризисное сопровождение, решение сложных коммуникационных кейсов</h1>
          </div>
          <div class="page__inner page__inner_small">
            <p class="page__counter page__counter_small">04</p>
            <h1 class="subtitle page__subtitle page__subtitle_small subtitle_red">Дизайн и продюсирование смыслов и событий</h1>
          </div>
        </div>
      </div>
    </div>

    <companies-background />

    <page-footer :next="{ name: 'dialog' }" />
  </div>
</template>

<script>
// eslint-disable-next-line
import { TimelineMax, TweenMax } from 'gsap'
import CompaniesBackground from '@/components/servicesSvg'
import PageFooter from '@/components/PageFooter'
import RouteMixin from '../mixins/route'

export default {
  name: 'companies',
  mixins: [RouteMixin],
  components: {
    CompaniesBackground,
    PageFooter
  },
  mounted () {
    new TimelineMax()
      .add(TweenMax.from('.companies-bg', 0.5, { opacity: 0 }))
      .add(TweenMax.from('.page__counter', 0.3, { y: '-20px', opacity: 0 }))
      .add(TweenMax.from('.page__subtitle', 0.3, { y: '-10px', opacity: 0 }))
  },
  beforeRouteLeave (to, from, next) {
    this.isDisabledRoute = true

    new TimelineMax()
      .add(TweenMax.to('.page__subtitle', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__counter', 0.3, { y: '20px', opacity: 0 }))
      .add(TweenMax.to('.companies-bg', 0.5, { opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  }
}
</script>
